export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const API_DUMMY_RESULT = false // NOTE: APIのDUMMYデータを利用する場合はここをTrueに変更

export const OFFICE_API_SCOPES = [
  'https://graph.microsoft.com/Calendars.ReadWrite',
  'https://graph.microsoft.com/User.Read',
  'https://graph.microsoft.com/Place.Read.All',
  'https://graph.microsoft.com/OnlineMeetings.ReadWrite',
  'offline_access'
]

export const STRIPE_PUBLIC_KEY = 'pk_test_SW28XDgxB3gOVDyVlZWrWZzW00VCWsH6Ik'
export const STRIPE_PLAN_OBJ = {
  Standard: process.env.VUE_APP_SCHEDULING_STANDARD,
  Trial: process.env.VUE_APP_SCHEDULING_TRIAL,
  Free: process.env.VUE_APP_SCHEDULING_FREE
}

export const ROLE = {
  Owner: 'Owner',
  Admin: 'Admin',
  Member: 'Member'
}

const env = !process.env.NODE_ENV ? 'development' : process.env.NODE_ENV
console.log(`Now Using ${env} env`) // eslint-disable-line no-console

export const MS_API_PARAMS: any = {
  clientId: process.env.VUE_APP_MS_CLIENT_ID,
  baseUri: process.env.VUE_APP_MS_BASE_URI,
  redirectUri: process.env.VUE_APP_MS_REDIRECT_URI,
  backendUri: process.env.VUE_APP_MS_BACKEND_URI,
  tenantIdCommon: process.env.VUE_APP_MS_TENANT_ID_COMMON,
  tenantId: process.env.VUE_APP_MS_TENANT_ID
}

export const GSUITE_FIREBASE_CONFIG_PARAMS: any = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FB_DB_URL,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_APP_ID,
  measurementId: process.env.VUE_APP_FB_MEASUREMENT_ID
}

export const TIMEZONE_LIST: Array<any> = [
  'US/Samoa', // UTC-11
  'Pacific/Samoa',
  'US/Hawaii', // UTC-10
  'US/Alaska', // UTC-8
  'America/Los_Angeles', //UTC-7
  'America/Phoenix', // UTC-7 (no sumertime)
  'America/Denver', // UTC-6
  'America/Chicago', // UTC-5
  'America/New_York', // UTC-4
  'America/Argentina/Buenos_Aires', // UTC-3
  'Brazil/DeNoronha', // UTC-2
  'Atlantic/Cape_Verde', // UTC-1
  'Europe/London', // UTC-0
  'Europe/Rome', // UTC+1
  'Europe/Athens', // UTC+2
  'Europe/Moscow', // UTC+3
  'Asia/Dubai', //UTC+4
  'Asia/Karachi', // UTC+5
  'Asia/Kolkata', // UTC+5:30
  'Asia/Dhaka', // UTC+6
  'Asia/Bangkok', // UTC+7
  'Asia/Shanghai', // UTC+8
  'Asia/Tokyo', // UTC+9
  'Asia/Seoul',
  'Asia/Vladivostok', // UTC+10
  'Pacific/Guam', // UTC+10
  'Pacific/Guadalcanal', // UTC+11
  'Pacific/Auckland' // UTC+12
].map((tz) => ({text: tz, value: tz}))

// NOTE: Add Agently app connection button link
export const ADD_TO_SLACK_LINK: string = process.env.VUE_APP_SLACK_CONNECTION_URL
export const ADD_TO_TEAMS_LINK: string = process.env.VUE_APP_TEAMS_CONNECTION_URL

// NOTE: Intercom Help Page URL
export const INTERCOM_URL: string = process.env.VUE_APP_INTERCOM_URL

import { NATIONS } from './nations'
export const NATIONS_LIST: Object[] = NATIONS

export const LICENCE_MAP: Object = {
  Scheduling: {
    Standard: { text: 'Standard', unitPrice: 600},
    Trial: { text: 'Trial', unitPrice: 0},
    Free: { text: 'Free', unitPrice: 0},
  }
}
